module.exports = __webpack_public_path__ + "gb.5df060a0b9178d03b093.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gb.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gb.svg
// module chunks = styles